import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { buildSignInUrl, signInWhenReachable } from "../../api/session";
import { useToast } from "../toast/toastContext";

/**
 * The sign-in link, returning to the current page once sign-in completes. A plain click checks the portal is up first, so a down
 * server is a toast here rather than the browser's own error page; other clicks (a new tab, say) keep the link's own behaviour.
 *
 * @param props.className - Classes for the link, a button style by default.
 * @param props.children - The link text, "Sign in" by default.
 */
export function SignInLink({ className = "button button-primary", children }: { className?: string; children?: React.ReactNode }): React.JSX.Element {
  const { t } = useTranslation();
  const toast = useToast();
  const location = useLocation();

  return (
    <a
      className={className}
      href={buildSignInUrl(location.pathname)}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }

        event.preventDefault();
        void signInWhenReachable(location.pathname).then((leaving) => {
          if (!leaving) {
            toast.show(t("session.signInUnavailable"), "error");
          }
        });
      }}
    >
      {children ?? t("session.signIn")}
    </a>
  );
}
